import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Job } from '../../class/job.class';
import { StatusType } from '../../types/status.type';

export const selectJobs = createFeatureSelector<readonly Job[]>('jobs');

export const selectAllJobs = createSelector(
  selectJobs,
  (jobs: readonly Job[]) => jobs ?? []
);

export const selectJobById = (jobId: number) => createSelector(
  selectJobs,
  (jobs: readonly Job[]) => jobs?.find(job => job.id === jobId)
);

export const selectJobsCount = createSelector(
  selectJobs,
  (jobs: readonly Job[]) => jobs?.length ?? 0
);

export const selectJobsByStatus = (status: StatusType) => createSelector(
  selectJobs,
  (jobs: readonly Job[]) => jobs?.filter(job => job.status === status) ?? []
);

export const selectJobsByStatusCount = (status: StatusType) => createSelector(
  selectJobsByStatus(status),
  (jobs: readonly Job[]) => jobs?.length ?? 0
);

export const selectJobIsCompleted = (jobId: number) => createSelector(
  selectJobById(jobId),
  (job: Job | undefined) => job ? job.status === 'COMPLETED' : false
);
